export const PKK_API_PATH = 'orbismap/external-services/pkk-proxy/api';
export const IRIS_ADMIN_API_PATH = 'orbismap/external-services/iris-admin';
